// extracted by mini-css-extract-plugin
module.exports = {"modalError":"_3B7zCZJC-X7esHrHBKHt1m","modalWarning":"_3EvtU4ySmTYqAbS89qIlqb"};